export default __webpack_public_path__ + "static/media/calendar-next.cfbc22ef.svg";